export default __webpack_public_path__ + "static/media/factory.1e272848.svg";